import { Component, inject, OnInit } from '@angular/core';
import { ReportInfo } from '@app/core/xprojector_backend/proto/xprojector.modulebms.export.pb';
import { XProjectorBmsExportClient } from '@app/core/xprojector_backend/xprojector-bms-export-client';
import { ClrLoadingState } from '@clr/angular';

@Component({
  selector: 'app-bms-configuration-reports',
  templateUrl: './bms-configuration-reports.component.html',
  styleUrls: ['./bms-configuration-reports.component.scss']
})
export class BmsConfigurationReportsComponent implements OnInit {

  private exportClient : XProjectorBmsExportClient = inject(XProjectorBmsExportClient);

  reports : ReportInfo[] = [];
  selectedReport : ReportInfo;
  executeState : ClrLoadingState = ClrLoadingState.DEFAULT;

  constructor() { }

  ngOnInit() {
    this.getReports();
  }

  async getReports() {
    this.reports = await this.exportClient.getReports();
    this.reports = this.reports.filter(x => !x.customerReport);
  }

  async executeReport() {
    if (this.selectedReport) {
      this.executeState = ClrLoadingState.LOADING;
      try {
        let result = await this.exportClient.executeReport('', '', this.selectedReport.id, this.selectedReport.filename)
      }
      finally {
        this.executeState = ClrLoadingState.SUCCESS;
      }
    }
  }

}
